<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item >首页</el-breadcrumb-item>
            <el-breadcrumb-item style="margin-bottom:20px">付费订单列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 搜索筛选 -->
        <el-form :inline="true" :model="formInline" class="user-search">
            <el-form-item label="订单编号">
                <el-input size="small" v-model="formInline.payOrderId" :disabled="editFlag" placeholder="昵称"></el-input>
            </el-form-item>
            <el-form-item label="用户手机号">
                <el-input size="small" v-model="formInline.userPhone" :disabled="editFlag" placeholder="手机号"></el-input>
            </el-form-item>
            <el-form-item label="下单时间">
                <el-date-picker
                    v-model="formInline.time"
                    type="daterange"
                    format="yyyy 年 MM 月 dd 日"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="支付通道">
                <el-select v-model="formInline.status" placeholder="请选择">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="已完成" :value="1"></el-option>
                    <el-option label="已退单" :value="0"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="">
                <el-button size="small" type="primary" @click="search">搜索</el-button>
                <el-button size="small" @click="empty">重置</el-button>
                <!-- <el-button size="small" type="primary" @click="addClick">创建总经销商</el-button> -->
            </el-form-item>
        </el-form>
        <el-form :inline="true" :model="formInline" class="user-search">
            <!-- <el-form-item label="平台累计收益：">
                12132元
            </el-form-item> -->
            <el-form-item label="">
                <el-button size="small" type="primary" @click="exportExcel">导出</el-button>
            </el-form-item>
            <el-form-item label="订单数">{{pageparm.total}}</el-form-item>
            <el-form-item label="订单金额总数">{{amountsum}}</el-form-item>
        </el-form>
        <el-table size="small" :data="listData" max-height="600" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
            <el-table-column show-overflow-tooltip prop="pay_order_id" label="订单编号" ></el-table-column>
            <el-table-column show-overflow-tooltip prop="STATUS" label="订单状态" >
                <template slot-scope="scope">
                    <div v-if="scope.row.STATUS == 0 && scope.row.reboundStatus == 0">退单中</div>
                    <div v-if="scope.row.STATUS == 0 && scope.row.reboundStatus == 2">退单失败</div>
                    <div v-if="scope.row.STATUS == 0 && scope.row.reboundStatus == 1">退单成功</div>
                    <div v-if="scope.row.STATUS == 1">已完成</div>
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="regulation_content" label="套餐内容" ></el-table-column>
            <!-- <el-table-column show-overflow-tooltip prop="orderTimeNum" label="包桌时长（分钟）" ></el-table-column> -->
            <el-table-column  prop="userName" label="下单用户昵称"></el-table-column>
            <el-table-column  prop="userPhone" label="下单用户手机号" ></el-table-column>
            <el-table-column  prop="createtime" label="下单时间" ></el-table-column>
            <el-table-column  prop="amount" label="下单金额（元）" >
                <template slot-scope="scope">
                    {{scope.row.amount/100}}
                </template>
            </el-table-column>
            <el-table-column  prop="payType" label="支付方式" >
                <template>
                    微信
                </template>
            </el-table-column>
            <el-table-column  prop="branch_name" label="门店名称" ></el-table-column>
            <el-table-column  prop="machineId" label="设备sn码" ></el-table-column>
            <!-- <el-table-column  prop="payChannelName" label="支付通道" ></el-table-column> -->
            <el-table-column align="center" label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" v-if="scope.row.STATUS == 0 && scope.row.reboundStatus == 0" type="text" @click="chargeback(scope.row)">退单</el-button>
                </template>
            </el-table-column>
        </el-table>
        <!-- 分页组件 -->
        <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <!-- 新增 -->
        <el-dialog :visible.sync="editFormVisible" width="30%" @click="closeDialog">
            <el-form label-width="120px" :model="editForm" :rules="rules" ref="editForm">
                <el-form-item label="推广员名称">
                <el-input size="small" v-model="editForm.name" style="width:230px" auto-complete="off" placeholder="请输入部门名称"></el-input>
                </el-form-item>
                <el-form-item label="手机号" >
                <el-input size="small" v-model="editForm.phone" style="width:230px" auto-complete="off" placeholder="请输入部门代码"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="closeDialog">取消</el-button>
                <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
            </div>
        </el-dialog>
        <!-- 详情 -->
        <el-dialog title="详情" :visible.sync="detailsFlag" width="30%" @click="closeDialog">
            <el-card class="box-card">
                <div>平台分成</div>
                <div>平台分成比例：{{divisionOrder.divisionSystem}}%</div>
                <div>平台分成金额：{{divisionOrder.systemAmount}}元</div>
            </el-card>
            <el-card class="box-card" style="margin-top:20px">
                <div>一级代理分成</div>
                <div>一级代理名称：{{divisionOrder.distributorName}}</div>
                <div>一级代理分成比例：{{divisionOrder.divisionDistributor}}%</div>
                <div>一级代理分成金额：{{divisionOrder.distributorAmount}}元</div>
            </el-card>
            <el-card class="box-card" style="margin-top:20px">
                <div>二级代理分成</div>
                <div>二级代理名称：{{divisionOrder.secDistributorName}}</div>
                <div>二级代理分成比例：{{divisionOrder.divisionSecDistributor}}%</div>
                <div>二级代理分成金额：{{divisionOrder.secDistributorAmount}}元</div>
            </el-card>
            <el-card class="box-card" style="margin-top:20px" v-if="divisionOrder.promoterName != undefined">
                <div>员工分成</div>
                <div>员工名称：{{divisionOrder.promoterName}}</div>
                <div>员工分成比例：{{divisionOrder.divisionPromoter}}%</div>
                <div>员工分成金额：{{divisionOrder.promoterAmount}}</div>
            </el-card>
            <el-card class="box-card" style="margin-top:20px">
                <div>商家分成</div>
                <div>商家名称：{{divisionOrder.storeName}}</div>
                <div>商家分成比例：{{divisionOrder.divisionStore}}%</div>
                <div>商家分成金额：{{divisionOrder.storeAmount}}</div>
            </el-card>
        </el-dialog>
        <!-- 绑定机器 -->
        <el-dialog title="总经销商详情" :visible.sync="bindingFlag" width="40%" @click="closeDialog">
                <el-form :inline="true" :model="formInline" label-width="120px" class="user-search">
                    <el-form-item label="主屏id">
                        <el-input size="small" v-model="formInline.name" :disabled="editFlag" placeholder="昵称"></el-input>
                    </el-form-item>
                    <el-form-item label="">
                        <el-button size="small" type="primary" @click="search">搜索</el-button>
                        <el-button size="small" @click="empty">重置</el-button>
                    </el-form-item>
                </el-form>
                <el-table size="small" :data="machineData" @selection-change="handleSelectionChange" max-height="400" highlight-current-row v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
                    <el-table-column  type="selection" width="55"></el-table-column>
                    <el-table-column  prop="主屏id" label="主屏id" ></el-table-column>
                    <el-table-column  prop="机器状态" label="机器状态" ></el-table-column>
                    <el-table-column align="center" label="操作">
                        <template slot-scope="scope">
                        <el-button size="mini" type="text" @click="handleEdit(scope.$index, scope.row)">添加</el-button>
                        </template>
                    </el-table-column>
                </el-table>
        </el-dialog>
</div>
</template>
<script>
import Pagination from '../../../components/Pagination'
import { loadPayOrderList , loadCustomerList , loadPayChannelList , getDivisionOrder , exportExcel ,branchOrderList , branchRebound} from '../../../api/userMG'
import { exportFun } from '../../../utils/export'
export default {
    data(){
        return{
            bindingFlag:false,
            activeName:"information",
            detailsFlag:false,
            options:[
                {
                value: '1',
                label: '上架'
                }, {
                value: '0',
                label: '下架'
                },
            ],
            editForm:{},
            editFormVisible:false,
            formInline: {
                page: 1,
                limit: 10,
                status:'',
                time:[],
                payOrderId:'',
                userPhone:''
            },
            machineData:[],
            listData: [{
                url:'https://thirdwx.qlogo.cn/mmopen/vi_32/8kKUTuTsoibsLSHPAXfUAjX7zPssdyWk8CorQicic8gzHHuu517RcdXEhKFtIqvNyR0APLeyPiaqn6iaGfWzJp4Er5Q/132',
                sort:'1',
                status:0,
            }], //用户数据
            // 分页参数
            pageparm: {
                currentPage: 1,
                pageSize: 10,
                total: 10
            },
            channelsList:[],
            divisionOrder:{},
            amountsum:''
        }
    },
    components: {
        Pagination
    },
    created(){
        this.getdata()
        this.loadPayChannelList()
    },
    methods:{
        exportExcel(){
            // exportFun()
            // exportExcel({
            //     id:this.formInline.name,
            //     phone:this.formInline.phone,
            //     payChannel:this.formInline.payChannel,
            //     createdFrom:this.formInline.time[0] == undefined?'':this.formInline.time[0],
            //     createdTo:this.formInline.time[1] == undefined?'':this.formInline.time[1]
            // }).then(res=>{
            //     // window.location.href = res
            // })
            exportFun('/branchOrder/export' , {
                status:this.formInline.status,
                payOrderId:this.formInline.payOrderId,
                userPhone:this.formInline.userPhone,
                starttime:this.formInline.time[0] == undefined?'':this.formInline.time[0],
                endtime:this.formInline.time[1] == undefined?'':this.formInline.time[1]
            })
            // this.$axios({
            //     method: "POST",
            //     responseType:'blob',
            //     url: "/yunyue-houtai/branchOrder/export",
            //     headers: {
            //         token: localStorage.getItem("logintoken"),//token值，根据接口要求传或者不传
            //     },
            //     data: 
            // }).then(res=>{
            //     const blob = new Blob([res.data]) // 转化为blob对象
            //     const filename = '订单列表.xlsx' // 判断是否使用默认文件名
            //     if (typeof window.navigator.msSaveBlob !== 'undefined') {
            //     window.navigator.msSaveBlob(blob, filename)
            //     } else {
            //     var blobURL = window.URL.createObjectURL(blob) // 将blob对象转为一个URL
            //     var tempLink = document.createElement('a') // 创建一个a标签
            //     tempLink.setAttribute('download', filename + '.xlsx') // 下载的文件名以及文件格式
            //     tempLink.style.display = 'none'
            //     tempLink.href = blobURL
            //     tempLink.setAttribute('download', filename) // 给a标签添加下载属性
            //     if (typeof tempLink.download === 'undefined') {
            //         tempLink.setAttribute('target', '_blank')
            //     }
            //     document.body.appendChild(tempLink) // 将a标签添加到body当中
            //     tempLink.click() // 启动下载
            //     document.body.removeChild(tempLink) // 下载完毕删除a标签
            //     window.URL.revokeObjectURL(blobURL)
            //     Message.success('导出成功')
            //     }
            // }).catch(err=>{
            //     if(err.response.status == 500){
            //         this.$message.error('服务异常')
            //     }
            // })
        },
        chargeback(row){
            
            this.$confirm('是否确认退单', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                // 删除
                branchRebound(row.pay_order_id).then(res => {
                        if (res.success) {
                            this.$message({
                            type: 'success',
                            message: '操作成功!'
                            })
                            this.getdata()
                        } else {
                            this.$message({
                            type: 'info',
                            message: res.message
                            })
                        }
                    })
                    .catch(err => {
                        this.loading = false
                        this.$message.error('操作失败，请稍后再试！')
                    })
                })
            .catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消！'
                })
            })
        },
        addClick(){
            this.editFormVisible = true
        },
        closeDialog(){
            this.editFormVisible = false
        },
        addBanner(){
            this.editFormVisible = true
        },
        empty(){
            this.formInline.page = 1
            this.formInline.limit = 10
            this.formInline.status = '' 
            this.formInline.payOrderId = ''
            this.formInline.userPhone = ''
            this.formInline.time = []
            this.getdata()
        },
        search(){
            console.log(this.formInline)
            this.formInline.page = 1
            this.formInline.limit = 10
            this.getdata()
        },
        loadPayChannelList(){
            loadPayChannelList({
                
            }).then(res=>{
                this.channelsList = res.channels
            })
        },
        getdata(){
            branchOrderList({
                page:this.formInline.page,
                pageSize:this.formInline.limit,
                status:this.formInline.status,
                payOrderId:this.formInline.payOrderId,
                userPhone:this.formInline.userPhone,
                starttime:this.formInline.time[0] == undefined?'':this.formInline.time[0],
                endtime:this.formInline.time[1] == undefined?'':this.formInline.time[1]
            }).then(res=>{
                this.listData = res.data.datalist
                this.pageparm.total = res.data.count
                this.amountsum = res.data.amountsum
            })
        },
        // 分页插件事件
        callFather(parm) {
            this.formInline.page = parm.currentPage
            this.formInline.limit = parm.pageSize
            this.getdata(this.formInline)
        },
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>


// WEBPACK FOOTER //
// src/views/SiteManagement/storeManagement/storeOrder.vue